import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

export default function CardDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const [card, setCard] = useState(null);
    const [payments, setPayments] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const cardContainerRef = useRef(null);

    const applicationId = "sandbox-sq0idb-ciK-AXiZD_0vLxk2-blcwA";
    const locationId = "LDF3D892Z9CYF";

    useEffect(() => {
        if (!location.state?.uuid) {
            toast.error("No payment information found");
            navigate('/make-payment');
            return;
        }

        const initializeSquarePaymentForm = async () => {
            if (!window.Square) {
                console.error("Square SDK not available.");
                return;
            }

            try {
                const paymentsInstance = window.Square.payments(applicationId, locationId);
                setPayments(paymentsInstance);
                const cardInstance = await paymentsInstance.card();
                
                if (cardContainerRef.current) {
                    cardContainerRef.current.innerHTML = '';
                }

                await cardInstance.attach('#card-container');
                setCard(cardInstance);
            } catch (error) {
                console.error("Error initializing Square Payments:", error);
                toast.error("Failed to initialize payment system");
            }
        };

        initializeSquarePaymentForm();

        return () => {
            if (cardContainerRef.current) {
                cardContainerRef.current.innerHTML = '';
            }
        };
    }, [location.state?.uuid, navigate]);

    const handleSubmitPayment = async () => {
        if (!card || !payments) {
            toast.error("Payment system not ready yet");
            return;
        }

        setIsProcessing(true);

        try {
            const tokenResult = await card.tokenize();
            
            if (tokenResult.status !== "OK") {
                console.error("Tokenization failed:", tokenResult.errors);
                toast.error("Please check your card details and try again.");
                return;
            }

            const token = tokenResult.token;

            // Proceed with payment
            const proceedPayload = {
                token: token,
                payment_uuid: location.state.uuid
            };

            console.log("Sending proceed payload:", proceedPayload);

            const proceedResponse = await axios.post(`${process.env.REACT_APP_URL}/payment/proceed`, proceedPayload);
            console.log("Proceed payment response:", proceedResponse.data);

            toast.success("Payment Processed Successfully!");
            navigate('/make-payment');
        } catch (error) {
            console.error("Full error object:", error);
            console.error("Error response:", error.response);
            console.error("Error message:", error.message);
            
            if (error.response) {
                toast.error(error.response.data?.message || error.response.data || "Server error occurred");
            } else if (error.request) {
                toast.error("No response from server. Please check your connection.");
            } else {
                toast.error("Error processing payment. Please try again.");
            }
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="container p-5">
            <div className="card-details-container">
                <h3>Enter Card Details</h3>
                <div id="card-container" ref={cardContainerRef} style={{ 
                    height: '100px',
                    marginBottom: '1rem',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '10px'
                }}></div>
                <button 
                    className="btn btn-primary" 
                    onClick={handleSubmitPayment}
                    disabled={isProcessing}
                >
                    {isProcessing ? "Processing..." : "Submit Payment"}
                </button>
            </div>
        </div>
    );
} 